import React from 'react';
import {SubmitHandler, useForm} from "react-hook-form";
import {baseUrl} from "../../../../../constants/constants";
import {errorToast, successToast} from "../../../../../shared/toastify";

interface ICreateTag{
    name: string
}

interface Props{
    close:() => void
}

const CreateTag = ({close}:Props) => {
    const{
        register,
        handleSubmit,
        formState:{errors},
        setError
    } = useForm<ICreateTag>()

    const submit: SubmitHandler<ICreateTag> = async (data: any)=>{
        try{
            const res = await fetch(`${baseUrl}tags`,{
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            });
            if (res.status === 200) {
                successToast('Тег добавлен. Обновите страницу');
                close()
            } else if (res.status === 401) {
                setError('root', {type: 'custom', message: ''})
                errorToast('Ошибка 401')
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <form
            className={'regForm'}
            onSubmit={handleSubmit(submit)}
        >
            <input
                type="text"
                className="regInput"
                placeholder={'Название тега'}
                {...register('name', {required: true})}
            />
            {errors.name && <p className={'wrong-message'}>Это поле обязательно</p>}

            <button className={'button form-btn'}>Создать</button>
        </form>
    );
};

export default CreateTag;